import {useSelector} from 'react-redux';

/**
 * Whether the current user has Open Banking account access.
 * @returns {boolean}
 */
export const useHasObAccounts = () => useSelector(state => state.openBanking.hasAccountAccess);
